import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import websiteConfigurationActions from "../store/actions/websiteConfiguration/websiteConfiguration.actions";

const useLogoConfiguration = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  // Subscribe to the Redux state for configurations
  const logoConfiguration = useSelector((state) => state.websiteConfigurationReducer.configurations.find((config) => config.key === "Logo"));

  useEffect(() => {
    const fetchLogo = async () => {
      if (!logoConfiguration) {
        try {
          setIsLoading(true);
          await dispatch(websiteConfigurationActions.getAllConfigurations());
        } catch (error) {
          console.error("Failed to fetch logo configuration:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLogo();
  }, [dispatch, logoConfiguration]);

  // Parse the configuration value if it exists
  const logoUrl = logoConfiguration?.value ? JSON.parse(logoConfiguration.value)?.Url : null;

  return { logoUrl, isLoading };
};

export default useLogoConfiguration;
